<template>
    <my-form ref="discountForm">
        <v-scroll-x-transition>
            <div class="mt-5 row" v-if="data && data.type == 'free_shipping_to_address'">
                <div class="col-md-6 d-flex flex-column">
                    <div class="d-flex flex-row align-center">
                        <v-img @click="$router.push('/coupons')" class="hover" max-height="30px"
                               max-width="28px" :src="$root.getSrc('/default/drop_icons/left_arrow.svg')"
                               contain></v-img>
                        <p class="ma-0 ml-4 fs-24 fw-400">
                            Add address from which you will have free pickup
                        </p>
                    </div>

                    <div class="row">
                        <div class="col-md-6 pb-0">
                            <v-text-field height="48" :rules="[validationRules.required]" v-model="data.name" dense color="blue_drop" class="mt-5 no-validation"  style="border-radius: 8px;" outlined  label="Discount Name"></v-text-field>
                        </div>
                        <div class="col-md-6 pb-0">
                            <v-text-field height="48" :rules="[validationRules.required]" v-model="data.code" dense color="blue_drop" class="mt-5 no-validation"  style="border-radius: 8px;" outlined  label="Code"></v-text-field>
                        </div>
                    </div>

                    <v-text-field height="48" :rules="[validationRules.required]" v-model="address.street" dense color="blue_drop" class="mt-5 no-validation"  style="border-radius: 8px;" outlined  label="Address"></v-text-field>


                    <div class="row">
                        <div class="col-md-6 pb-0">
                            <v-select item-text="name" item-value="code"  dense height="48" color="blue_drop" class="no-validation mt-5" :items="countries" outlined v-model="address.country" label="Country" :rules="[validationRules.required]"></v-select>
                        </div>
                        <div class="col-md-6 pb-0">
                            <v-text-field :rules="[validationRules.required]" v-model="address.city" dense height="48" color="blue_drop" class="no-validation mt-5"  style="border-radius: 8px;" outlined  label="City"></v-text-field>

                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-6 pt-0">
                            <v-text-field v-if="address.country != 'AU'" :rules="[validationRules.required]" v-model="address.state" dense height="48" color="blue_drop" class="no-validation mt-5"  style="border-radius: 8px;" outlined  label="State"></v-text-field>
                            <v-select v-else item-text="name" item-value="abbreviation"  dense height="48" color="blue_drop" class="no-validation mt-5" :items="states()" outlined v-model="address.state" label="State" :rules="[validationRules.required]"></v-select>

                        </div>
                        <div class="col-md-6 pt-0">
                            <v-text-field :rules="[validationRules.required]" v-model="address.postal" dense height="48" color="blue_drop" class="no-validation mt-5"  style="border-radius: 8px;" outlined  label="Postal code"></v-text-field>
                        </div>
                    </div>
                    <div class="d-flex flex-row mt-5">
                        <primary-button @clickBtn="save" :activeButton="true">{{data.id ? 'Update' : 'Create'}} coupon</primary-button>
                        <secondary-button v-if="data.id" @clickBtn="deleteDiscount" class="ml-5" :activeButton="true">Remove coupon</secondary-button>
                    </div>
                </div>
            </div>
            <div class="mt-5 row" v-if="data && data.type == 'codes'">
                <div class="col-md-6 d-flex flex-column">
                   <div class="d-flex flex-row align-center">
                       <v-img @click="$router.push('/coupons')" class="hover" max-height="30px"
                              max-width="28px" :src="$root.getSrc('/default/drop_icons/left_arrow.svg')"
                              contain></v-img>
                       <p class="ma-0 ml-4 fs-24 fw-400">
                           Add percentage or fixed discount with code
                       </p>
                   </div>


                    <div class="row">
                        <div class="col-md-12 pb-0">
                            <v-text-field height="48" :rules="[validationRules.required]" v-model="data.name" dense color="blue_drop" class="mt-5 no-validation"  style="border-radius: 8px;" outlined  label="Discount Name"></v-text-field>
                        </div>

                    </div>

                    <div class="row">
                        <div class="col-md-6 pb-0">
                            <v-text-field height="48" :rules="[validationRules.required]" v-model="data.code" dense color="blue_drop" class="mt-5 no-validation"  style="border-radius: 8px;" outlined  label="Code"></v-text-field>
                        </div>
                        <div class="col-md-6">
                            <v-text-field height="48" :rules="[validationRules.required]" v-model="data.max_uses" dense color="blue_drop" class="mt-5 no-validation"  style="border-radius: 8px;" outlined  label="Max uses"></v-text-field>

                        </div>

                    </div>

                    <div class="row">
                        <div class="col-md-6">
                            <v-text-field dense height="48" style="border-radius: 8px;" v-model="discount_value" :class="[discount_value.length == 0 ? 'product-name-filter' : '']" color="blue_drop" type="number" min="0" step="1" outlined :rules="[validationRules.required]" label="Discount value"></v-text-field>
                        </div>
                        <div class="col-md-6">
                            <v-btn v-ripple="false"  v-for="method in category_methods" class="small-btns mr-5" @click="category_method = method.method" :class="[category_method != method.method ? 'product-inactive-button' : '']" outlined :color="category_method != method.method ? 'super_light_blue' : 'blue_drop'">{{method.name}}</v-btn>

                        </div>
                    </div>

                    <div class="d-flex flex-row mt-5">
                        <primary-button @clickBtn="save" :activeButton="true">{{data.id ? 'Update' : 'Create'}} coupon</primary-button>
                        <secondary-button v-if="data.id" @clickBtn="deleteDiscount" class="ml-5" :activeButton="true">Remove coupon</secondary-button>
                    </div>
                </div>
            </div>
            <div class="mt-5 row" v-else-if="data && data.type == 'shipping'">
                <div class="col-md-6 d-flex flex-column">
                    <p class="ma-0 fs-24 fw-400">
                        Put cart value from which you will have free shipping
                    </p>
                    <v-text-field type="number" min="0" step="0.01" :rules="[validationRules.required]" v-model="data.discount_number" dense height="48" color="blue_drop" class="no-validation mt-5"  style="border-radius: 8px;" outlined  label="Cart value">
                        <template v-slot:append>
                            <span class="fs-14 mt-3 fw-400">AUD</span>
                        </template>
                    </v-text-field>
                    <v-text-field v-if="false" :rules="[!data.code_required ? validationRules.required : null]" v-model="data.code" dense height="48" color="blue_drop" class="no-validation mt-5"  style="border-radius: 8px;" outlined  label="Coupon"></v-text-field>
                    <div v-if="false" class="d-flex align-center justify-start pt-5 radio_btn" style="padding-right: 12px; height: 100%;">
                        <label style="margin-right: 8px;" :style="{'color': data.code_required ? 'black' : '#2F80ED'}" class="v-label theme--light fs-18 fw-600">{{$t('Require coupon name')}}</label><v-switch dense inset v-model="data.code_required" color="#2F80ED" class="no-validation" style="padding-top: 0; margin-top: 0;" :label="$t('Add automatically to order')"></v-switch>
                    </div>
                    <div class="d-flex flex-row mt-5">
                        <primary-button @clickBtn="save" :activeButton="true">{{data.id ? 'Update' : 'Create'}} coupon</primary-button>
                        <secondary-button v-if="data.id" @clickBtn="deleteDiscount" class="ml-5" :activeButton="true">Remove coupon</secondary-button>
                    </div>
                </div>
            </div>
            <div class="mt-5 row" v-else-if="data && data.type == 'category'">
                <div class="col-md-12 d-flex justify-end">
                    <secondary-button v-if="data.id" @clickBtn="deleteDiscount" :activeButton="true">Remove coupon</secondary-button>
                    <primary-button class="ml-4" @clickBtn="save" :activeButton="true">{{data.id ? 'Update' : 'Create'}} coupon</primary-button>
                </div>
                <div style="background-color: #FFFFFF; border-radius: 16px;" class="col-md-12 pa-5 mt-5">
                    <div class="row grey-line">
                        <div class="col-md-6">
                            <p class="ma-0 fw-600 fs-18">
                                Put your discount value for chosen categories
                            </p>
                        </div>
                        <div class="col-md-6 pb-0 d-flex flex-row align-start">
                            <v-text-field v-model="discount_value" style="border-radius: 8px;" dense height="48" color="blue_drop" type="number" min="0" step="0.01" outlined :rules="[validationRules.required]" label="Discount value"></v-text-field>
                            <v-btn v-ripple="false" v-for="method in category_methods" class="small-btns ml-5" @click="category_method = method.method" :class="[category_method != method.method ? 'product-inactive-button' : '']" outlined :color="category_method != method.method ? 'super_light_blue' : 'blue_drop'">{{method.name}}</v-btn>
                        </div>
                    </div>
                    <div class="row d-flex flex-column mt-5">
                        <div class="col-md-12">
                            <p class="ma-0 fw-600 fs-18">Select categories for this discount</p>
                        </div>
                        <div class="col-md-12 d-flex flex-row flex-wrap" v-if="categories">
                            <v-btn v-ripple="false" class="small-btns" @click="data.category_id = 'all';" :class="[data.category_id  != 'all' ? 'product-inactive-button' : '']" outlined :color="data.category_id  != 'all' ? 'super_light_blue' : 'blue_drop'">All categories ({{categories.length}})</v-btn>
                            <v-btn v-ripple="false" :key="category.id" v-for="category in categories" class="small-btns ml-2" @click="data.category_id = category.id;" :class="[data.category_id  != category.id ? 'product-inactive-button' : '']" outlined :color=" data.category_id  != category.id ? 'super_light_blue' : 'blue_drop'">{{category.name}}</v-btn>
                        </div>
                    </div>

                </div>
            </div>
            <div class="mt-5 row" v-else-if="data && data.type == 'user_discount'">
                <div class="col-md-12 d-flex justify-end">
                    <secondary-button v-if="data.id" @clickBtn="deleteDiscount" :activeButton="true">Remove coupon</secondary-button>
                    <primary-button @clickBtn="save" class="ml-4" :activeButton="true">Save changes</primary-button>
                </div>
                <div style="background-color: #FFFFFF; border-radius: 16px;" class="col-md-12 pt-5 pb-5 mt-5">
                    <div class="row pl-5 pr-5 pt-5">
                        <div class="col-md-12 pb-0 d-flex flex-row align-start">
                            <v-text-field class="mr-10" dense height="48" style="border-radius: 8px;" v-model="discount_value" :class="[discount_value.length == 0 ? 'product-name-filter' : '']" color="blue_drop" type="number" min="0" step="0.01" outlined :rules="[validationRules.required]" label="Discount value"></v-text-field>
                            <v-btn v-ripple="false" v-for="method in category_methods" class="small-btns ml-5" @click="category_method = method.method" :class="[category_method != method.method ? 'product-inactive-button' : '']" outlined :color="category_method != method.method ? 'super_light_blue' : 'blue_drop'">{{method.name}}</v-btn>
                            <v-text-field v-model="data.code" :class="[data.code && data.code.length == 0 ? 'product-name-filter' : '']"  dense height="48"  style="border-radius: 8px;" color="blue_drop" class="ml-10" outlined :rules="[validationRules.required]" label="Coupon"></v-text-field>
                        </div>
                    </div>
                </div>
                <div style="background-color: #FFFFFF; border-radius: 16px;" class="col-md-12 pt-5 pb-5 mt-10">
                    <div class="row pl-5 pr-5 pt-0 pb-1 grey-line">
                        <div class="col-md-12 d-flex justify-end align-center ">
                            <div class="mr-4 d-flex flex-row">
                                <p class="ma-0 fw-400 fs-18 d-flex align-center flex-row selectAmount">Show on site:
                                    <v-select
                                        style="display: inline-block;width: 20px!important;"
                                        class="no-validation ml-2"
                                        :items="[5,10,15]"
                                        v-model="customersAmount"
                                        dense
                                        ref="products_amount"
                                    ></v-select>
                                    <v-img @click="$refs.products_amount.isMenuActive = true" class="hover" max-width="15px" max-height="15px" :src="$root.getSrc('/default/drop_icons/arrow_down.svg')" ></v-img>
                                </p>
                            </div>
                            <div class="ml-4 selectAmount d-flex flex-row align-center">
                                <v-select
                                    class="no-validation"
                                    :items="customersSortBySelect"
                                    v-model="customersSortBy"
                                    dense
                                    ref="filter_by"
                                ></v-select>
                                <v-img @click="$refs.filter_by.isMenuActive = true" class="ml-2 hover" max-width="15px" max-height="15px" :src="$root.getSrc('/default/drop_icons/arrow_down.svg')" ></v-img>
                            </div>
                        </div>
                    </div>
                    <div class="row pa-5 grey-line">
                        <div class="col-md-5 justify-start align-center">
                            <v-text-field color="blue_drop" v-model="term" class="no-validation" dense height="48" style="border-radius: 8px;" outlined append-icon="mdi-magnify" :class="[term.length == 0 ? 'product-name-filter' : '']" placeholder="What you are looking for?"></v-text-field>
                        </div>
                    </div>
                    <div class="row pa-5" v-if="users">
                        <div class="drop-checkbox header-center-align pt-5 w-100">
                            <v-data-table
                                class="order-table"
                                :loading="load"
                                :items="users"
                                :headers="headers"
                                show-select
                                :hide-default-footer="true"
                            >
                                <template v-slot:item.is_discount="{item}">
                                    <v-switch dense inset color="#2F80ED" class="no-validation" style="padding-top: 0; margin-top: 0;" :label="$t('Active')"></v-switch>
                                </template>
                            </v-data-table>
                        </div>
                    </div>
                </div>

            </div>
            <div class="mt-5 row" v-else-if="data && data.type == 'products'">
                <div class="col-md-12 d-flex justify-end">
                    <secondary-button :activeButton="true" @clickBtn="deleteDiscount" v-if="data.id && data.products && data.products.length > 0" >Remove coupon</secondary-button>
                    <primary-button class="ml-4" @clickBtn="save" :activeButton="data.products && data.products.length > 0">{{data.id ? 'Update' : 'Create'}} coupon</primary-button>
                </div>
                <div v-if="data.products && data.products.length > 0"  class="col-md-12 pt-5 pb-5 mt-5">
                    <div class="row">
                        <div class="col-md-12 mb-5 pb-0 d-flex flex-row align-center white-container" style="background-color: #FFFFFF; border-radius: 16px;" v-for="(product,index) in data.products">
                            <div class="row pa-3">
                                <div class="col-md-2">
                                    <v-img width="100%" height="75px" contain :src="getSrc(data.id ? product.preview_photos ? product.preview_photos[0] : product.product.preview_photos[0] : product.preview_photos[0] )"></v-img>
                                </div>
                                <div class="col-md-4 d-flex flex-column flex-wrap justify-center">
                                    <div><span class="font-weight-bold">Product name:</span>&nbsp;<span style="font-weight: 400;">{{data.id ?  product.preview_photos ? product.name : product.product.name : product.name}}</span></div>
                                    <div><span class="font-weight-bold">Current margin:</span>&nbsp;<span style="font-weight: 400;">{{product.price}}&nbsp;AUD</span></div>
                                </div>
                                <div class="col-md-4 d-flex justify-center align-center">
                                    <v-text-field type="number" min="0" :max="product.price" v-model="product.new_price"  dense height="48"  style="border-radius: 8px;" color="blue_drop" class="ml-10 no-validation" outlined :rules="[validationRules.required]" label="New margin"></v-text-field>
                                </div>
                                <div class="col-md-2 d-flex justify-center align-center">
                                    <secondary-button @clickBtn="data.products.splice(index, 1)" :activeButton="true">Remove product</secondary-button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div style="background-color: #FFFFFF; border-radius: 16px;" class="col-md-12 pt-5 pb-5 mt-10">
                    <product-table @addProduct="addProduct" :used-products="usedProducts" :show-filters="false"></product-table>
                </div>

            </div>
        </v-scroll-x-transition>
    </my-form>
</template>
<script>
import ProductTable from '../products/product-table';

import {getBreads, editBread, storeBread, getBread, deleteBread} from "../../api/bread";
import {getUsers} from "@/api/user";
import {checkCodes} from "@/api/promotions";
    export default {
        props:['value'],
        components:{ProductTable},
        data:() => {
            return{
                term: '',
                users:null,
                headers:[
                    {
                        text: 'Customer',
                        value: 'name',
                        sortable: false,
                        // width: '120px',
                        align: 'left'
                    },
                    {
                        text: 'Customer e-mail',
                        value: 'email',
                        sortable:false,
                        // width: '150px',
                        align: 'left'
                    },

                    {
                        text: 'Discount',
                        value: 'is_discount',
                        sortable: false,
                        // width:'90px',
                        align: 'left'
                    },
                ],
                selected_category: 'all',
                category_method: 'fixed',
                category_methods: [{
                    method: 'fixed',
                    name: 'AUD'
                },{
                    method: 'percentage',
                    name: '%'
                }],
                discount_value: 0,
                website_products: null,
                categories:null,
                product_term: '',
                data:null,
                address:{
                    'country': 'AU'
                },
                newCsv: null,
                loading: false,
                importedDiscounts: null,
                showUploadInput: true,
                type: null,
                customersAmount: 5,
                customersSortBy: 'Recently added',
                customersSortBySelect: ['Recently added', 'Margin: High-low', 'Margin: Low-High'],
            }
        },
        watch:{
            value: function(){
                this.setData();
            },
            data:{
                handler: function () {
                    this.$emit('input', this.data);
                    if(this.data && this.data.type == 'category' && !this.categories){
                        this.getCategories();
                    }
                    if(this.data && this.data.type == 'products' && !this.website_products){
                        this.getProducts();
                    }
                },
                deep: true
            }
        },
        computed:{
            website(){
                return this.$store.getters.activeWebsite;
            },
            app(){
                return this.$store.getters.app;
            },
            countries() {
                return this.app.countries;
            },
            discountDescription(){
                let text='';
                if(this.data.type){
                    switch(this.data.type){
                        case 'shipping':
                            text='Free shipping from fixed value.';
                            break;
                        case 'free_shipping_to_address':
                            text='Choose address where customer can pick up order.';
                            break;
                        case 'codes':
                            text='Discount with code.';
                            break;
                        case 'products':
                            text='Change margin on selected products.';
                            break;
                        case 'category':
                            text='Percentage discount on selected categories.';
                            break;
                        case 'import_csv':
                            text='Upload csv file with filled data.';
                            break;
                    }
                }
                return text;
            },
            usedProducts(){
                let ids = [];
                if(this.data && this.data.id && this.data.products) {
                    this.data.products.forEach(product => {
                        product.preview_photos ? ids.push(product.id) : ids.push(product.product_id);
                    })
                }
                if(this.data && !this.data.id && this.data.products) this.data.products.forEach(product => ids.push(product.id));
                return ids;
            }
        },
        mounted(){
            this.type = this.$route.params.type;
            if(this.type == 'user_discount'){
                this.getUsers();
            }
            this.setData();
            this.getCategories();
            this.getProducts();
        },
        methods:{
            addProduct(product){
                if(!this.data.products) this.$set(this.data,'products',[]);
                product.new_price = product.price;
                if(this.data.products) this.data.products.push(product);
            },
            deleteDiscount(){
                this.$confirm(this.$t('Discount deleting'), this.$t('Are you sure, you want delete this discount?'), {accept: {text: 'Yes', color:'red'}, cancel: {text: 'No'}}).then(res => {
                    deleteBread('Promotion', this.data.id, {model_name:'Shop/Promotion'}).then(response => {
                        this.$router.push('/coupons');
                        this.$store.commit('app/ADD_MESSAGE', {text: this.$t('Discount successfully deleted'), type: 'success'});
                    }).catch(e => {
                        this.$store.commit('app/ADD_MESSAGE', {text: 'Something went wrong', type:'error'});
                        this.$router.push('/coupons');
                    })
                })
            },
            getUsers(){
              getUsers(this.website.id).then(res=>{
                  this.users = res;
              })
            },
            setData(){
                if(this.$route.params.id){
                    getBread('Promotion', this.$route.params.id,{model_name:'Shop/Promotion', relations:['childDiscounts','products']}).then(response => {
                        this.data = response;
                        if(response && (response.discount_number || response.discount_percentage)){
                            if(response.discount_percentage) {
                                this.$set(this.data, 'discount_type', 'percentage');
                                this.discount_value = response.discount_percentage;
                            }
                            if(response.discount_number) {
                                this.$set(this.data, 'discount_type', 'fixed');
                                this.discount_value = response.discount_number;
                            }
                            if(response.category_id == 0) this.$set(this.data, 'category_id', 'all');

                        }
                        if(this.data.type==='free_shipping_to_address'){
                            this.address=JSON.parse(this.data.description);
                        }
                        if(this.data.products){
                            this.data.products.forEach((prod,index) => {
                                this.$set(prod,'new_price',prod.price);
                            })
                        }
                    }).catch(e => {
                        this.$store.commit('app/ADD_MESSAGE', {text: 'Discount not found', type:'error'});
                        this.$router.push('/coupons');
                    })
                }else{
                    this.initNewData();
                }
            },
            getProducts(){
                getBreads('Product', {model_name: 'Product', per_page: 10, dont_calculate_price: 1, website_id: this.website.id, term: this.product_term, select:['products.id', 'products.name', 'products.price', 'products.preview_photos', 'product_id']}).then(response => {
                    this.website_products = response.data;
                    if(this.data.products){
                        this.data.products.forEach((prod,index) => {
                            var finded = this.website_products.find(x => x.id == prod.product_id);
                            if(finded){
                                this.data.products[index] = {...finded, ...prod};
                            }
                        })
                    }
                })
            },
            getCategories(){
                getBreads('Category', {per_page: 1000000, website_id: this.website.id}).then(response => {
                    this.categories = response.data;
                })
            },
            initNewData(){
                this.data = {
                    products: [],
                    discount_number: null,
                    discount_percentage: null,
                    discount_type: null,
                    code: null,
                    type: this.$route.params.type,
                    category_id: null
                }
            },
            save(){
                if(this.$refs.discountForm.my_validate()){
                    if(this.data.type == 'free_shipping_to_address'){
                        this.data.name = 'Free shipping to address';
                        this.address.country = this.address.country.toUpperCase();
                        this.data.description=JSON.stringify(this.address);
                    }
                    if(this.data.type == 'category' || this.data.type == 'codes'){
                        if(this.category_method == 'fixed'){
                            this.data.discount_number = this.discount_value;
                            this.data.discount_percentage = null;
                        } else {

                            this.data.discount_percentage = this.discount_value <= 100 ? this.discount_value : 100;
                            this.data.discount_number = null
                        }
                    }

                    if(this.data.products){
                        let change = !this.data.id;
                        this.data.products.forEach(prod=>{
                            prod.price = prod.new_price;
                            if(!prod.promotion_id) prod.product_id = prod.id;
                            if(prod.promotion_id) prod.product_id = prod.product.id;
                        })
                    }
                    this.data.max_uses = this.data.max_uses ? this.data.max_uses : 99999;
                   this.data.id ? this.updateDiscount() : this.createDiscount();
                } else {
                    this.$store.commit('app/ADD_MESSAGE', {text: 'Invalid address', type: 'error'});
                }
            },
            createDiscount(){
                var func = storeBread('Promotion', {model_name:'Shop/Promotion', ...this.data});
                func.then(response => {
                    this.$emit('input', null);
                    this.$emit('saved');
                    this.$store.commit('app/ADD_MESSAGE', {text: 'Discount successfully created', type: 'success'});
                    this.$router.push('/coupons');
                }).catch(e => {
                    this.$store.commit('app/ADD_MESSAGE', {text: e.response.data.errors.code[0], type:'error'});
                })
            },
            updateDiscount(){
                var func = editBread('Promotion', {model_name:'Shop/Promotion', ...this.data}, this.data.id);
                func.then(response => {
                    this.$emit('input', null);
                    this.$emit('saved');
                    this.$store.commit('app/ADD_MESSAGE', {text: 'Discount successfully updated', type: 'success'});
                    this.$router.push('/coupons');
                }).catch(e => {
                    this.$store.commit('app/ADD_MESSAGE', {text: e.response.data.errors.code[0], type:'error'});
                })
            },
            saveDiscount(){
                if(this.$refs.discount_form.my_validate()){
                    if(this.data.products){
                        this.data.products.map(function (prod) {
                            prod.product_id = (prod.product)? prod.product.id : prod.id;
                            return prod;
                        })
                    }
                    if(this.data.type==='free_shipping_to_address'){
                        this.data.description=JSON.stringify(this.address);
                        this.data.max_uses = 9999;
                    }
                    if(this.data.multiple){
                        this.data.max_uses = 1;
                        this.data.is_master = 1;
                    }
                    if(this.data.id){
                        var func = editBread('Promotion', {model_name:'Shop/Promotion', ...this.data}, this.data.id);
                        this.data.child_discounts.forEach(child=>{
                            editBread('Promotion', {model_name:'Shop/Promotion', ...child}, child.id);
                        })
                    }else{
                        if(this.data.type === 'import_csv'){
                            let codesToCheck = [];
                            this.importedDiscounts.forEach(code=>{
                                codesToCheck.push(code.code);
                            })
                            let checkCod = checkCodes({codes:codesToCheck});
                            checkCod.then(res=>{
                                if(res == true){
                                    var func2 = storeBread('Promotion', {model_name:'Shop/Promotion', ...this.data});
                                    func2.then(response=>{
                                        this.importedDiscounts.forEach(imported=>{
                                            imported.name = this.data.name;
                                            imported.max_uses = 1;
                                            imported.type = 'codes';
                                            imported.used = 0;
                                            imported.archived = 0;
                                            imported.parent_discount_id = response.id;
                                            imported.shopName = this.$store.getters.activeWebsite.name;
                                            imported.website_url = this.$store.getters.activeWebsite.link;
                                            var func = storeBread('Promotion', {model_name:'Shop/Promotion', ...imported});
                                        })
                                        this.$store.commit('app/ADD_MESSAGE', {text: 'Successfully created discounts', type: 'success'});
                                        this.$router.push('/discounts');
                                    })
                                } else {
                                    this.importedDiscounts.forEach(imported=>{
                                        if(res.indexOf(imported.code)>=0) {
                                            this.$store.commit('app/ADD_MESSAGE', {text: 'Promotion with this code already exist. Please change '+imported.code+' code', type:'error'});
                                            imported.code = null;
                                        }
                                    })
                                }
                            })

                        } else {
                            var func = storeBread('Promotion', {model_name:'Shop/Promotion', ...this.data});
                        }
                    }
                    if(this.data.type !== 'import_csv'){
                        func.then(response => {
                            this.$emit('input', null);
                            this.$emit('saved');
                            if(this.$route.params.id){
                                this.$store.commit('app/ADD_MESSAGE', {text: 'Successfully updated discount', type: 'success'});
                            } else {
                                this.$store.commit('app/ADD_MESSAGE', {text: 'Successfully created discount', type: 'success'});
                            }

                            this.$router.push('/discounts');
                        }).catch(e => {
                            this.$store.commit('app/ADD_MESSAGE', {text: e.response.data.errors.code[0], type:'error'});
                        })
                    }

                }
            },
            states(){
                return this.app.states[this.address.country];
            },
        }
    }
</script>
<style>
.v-text-field__slot input, .v-text-field__slot label:not(.v-label--active){
    font-size: 14px !important;
    font-weight: 400!important;
}

.v-label--active{
    font-weight: 400;
    font-size: 14px;
    color: #2F80ED!important;
}
body .radio_btn .v-input--selection-controls__input label{
    font-weight: 400;
    font-size: 18px!important;
}
.radio_btn .v-input--is-label-active label{
    color: #2F80ED!important;
}
.selectAmount .v-input__append-inner {
    display: none!important;
}
.selectAmount .v-input__slot::before{
    display: none!important;
}
.selectAmount .v-input__slot::after{
    display: none!important;
}
.selectAmount .v-select__selection{
    color: #2F80ED!important;
    font-size: 18px!important;
}
.selectAmount .v-select__selections input {
    display: none!important;
}

.selectAmount .v-select__selection--comma{
    overflow: visible!important;
}

.v-select .v-label {
    font-weight: 400!important;
    font-size: 14px!important;
    padding-top: 4px!important;
}

</style>
